import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';

const Container = Styled.div`
  font-size: ${Theme.fontSizeText};
  font-family: ${Theme.fontFamily};
  background-color: ${Theme.white};
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  margin-bottom: 25px;

  &.primary {
    background-color: ${Theme.blue};
  }

  p:first-child {
    margin-top: 0px;
  }

  p:last-child {
    margin-bottom: 0px;
  }

  .content {
    padding: 20px 20px;
  }
`;

const Bar = Styled.div`
  justify-content: flex-start;
  background-color: ${Theme.lightGray2};
  display: flex;
  align-items: center;
  padding: 8px 10px;

  &.align-right {
    justify-content: flex-end;
  }
`;

/**
 * @oaram {string} className
 */
const StyledNekoContainer = props => {

  const { children, header, headerAlign = 'left', footer, footerAlign = 'right', className, style = {} } = props;

  return (
    <Container className={className || ''} style={style}>
      {header && <Bar className={`align-${headerAlign}`}>{ header }</Bar>}
      <div className="content">
        { children }
      </div>
      {footer && <Bar className={`align-${footerAlign}`}>{ footer }</Bar>}
    </Container>
  );
};

const NekoContainer = (props) => {
  return (<StyledNekoContainer {...props} />);
}

NekoContainer.propTypes = {
  header: PropTypes.element,
  headerAlign: PropTypes.oneOf(['left', 'right']),
  footer: PropTypes.element,
  footerAlign: PropTypes.oneOf(['left', 'right']),
  className: PropTypes.string,
  style: PropTypes.object
};
NekoContainer.defaultProps = {
  header: undefined,
  headerAlign: 'left',
  footer: undefined,
  footerAlign: 'right',
  className: undefined,
  style: {}
};

export { NekoContainer };
